<template>
  <div class="m-2" style="min-width: 30vw">
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="true"
    ></b-loading>
    <template v-if="cart.length != 0">
      <sequence-activity-list-settings
        :currentSequence="currentSequence"
        :activities="cart"
        @updateCart="updateCart"
        @updateRepetitionActivity="updateRepetitionActivity"
        @updateVersionNumberActivity="updateVersionNumberActivity"
        @removeActivity="removeFromCart"
        @removeAllActivities="emptyCart"
        context="Cart"
      ></sequence-activity-list-settings>
      <div class="has-text-centered mt-2">
        <b-button
          v-if="isCurrentUserPremiumOrMore"
          :disabled="currentSequence.id !== null"
          class="button is-primary"
          @click="modalOpenNewSequence()"
        >
          {{
            currentSequence.id === null
              ? $t("Cart.CREATE_SEQUENCE")
              : $t("Cart.SEQUENCE_CREATED") + "(" + currentSequence.name + ")"
          }}
        </b-button>
        <b-button
          v-else
          class="button is-primary"
          @click="$router.push('/sequencePreview')"
          >{{ $t("Cart.CREATE_SEQUENCE")
          }}<b-tag
            v-if="!checkPermission('sequence_get_own')"
            class="ml-2"
            type="is-dark"
            >Premium</b-tag
          ></b-button
        ><br />
        <b-tooltip
          v-if="currentSequence.id !== null"
          :label="$t('SequenceList.TOOLTIP.SHARE')"
          position="is-bottom"
        >
          <b-button
            type="is-primary"
            class="m-3"
            @click="isShareModalActive = true"
            pack="fas"
            icon-left="share-alt"
            :label="$t('Use.SHARE')"
          >
          </b-button>
        </b-tooltip>
        <b-modal
          v-model="isShareModalActive"
          :can-cancel="['outside', 'escape']"
          @close="closeShareModal"
          has-modal-card
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Modal share"
          close-button-aria-label="Close"
          ref="shareModal"
        >
          <ShareSequenceModal
            :id="currentSequence.id"
            :name="currentSequence.name"
            :shared="currentSequence.shared"
            :currentKeyEnabled="currentSequence.keyEnabled"
            :currentKey="currentSequence.key"
            @closeShareSequenceModal="closeShareModal"
            @updateSequenceShared="updateTableSequence"
          ></ShareSequenceModal>
        </b-modal>
      </div>
    </template>
    <template v-else>
      <b-notification
        :closable="false"
        type="is-warning is-light"
        class="container has-text-centered"
      >
        {{ $t("Cart.CART_EMPTY") }}
        <img :src="addToCartUrl" alt="Add to Sequence Icon"
      /></b-notification>
    </template>
  </div>
</template>

<script>
import addToCartUrl from "@/assets/images/cart-plus.svg";
import { mapState, mapGetters } from "vuex";
import SequenceDataService from "../../src/services/SequenceDataService";
import UtilsMixin from "../mixins/UtilsMixin.js";
import SequenceActivityListSettings from "./SequenceActivityListSettings";
import ShareSequenceModal from "./ShareSequenceModal.vue";

export default {
  name: "Cart",
  mixins: [UtilsMixin],

  components: {
    SequenceActivityListSettings,
    ShareSequenceModal,
  },
  computed: {
    ...mapState(["cart"]),
    ...mapGetters(["cartCount"]),
  },
  data: function () {
    return {
      addToCartUrl,
      currentSequence: { id: null },
      isLoading: false,
      isShareButtonShown: false,
      isShareModalActive: false,
    };
  },
  methods: {
    closeShareModal() {
      this.isShareModalActive = false;
      this.$emit("openDropdownCart"); // le dropdown se ferme automatiqument => On envoie un event pour le réouvrir
    },
    removeFromCart(index) {
      console.log("removeFromCart");
      this.currentSequence.id = null;
      this.$store.commit("removeFromCart", index);
    },
    emptyCart() {
      this.currentSequence = { id: null };
      this.$store.commit("emptyCart");
    },
    updateCart() {
      this.currentSequence.id = null;
    },

    updateRepetitionActivity(index, repetitions) {
      console.log("updateRepetitionActivity");
      this.currentSequence.id = null;
      // Appelle l'action Vuex pour mettre à jour les répétitions de l'activité
      this.$store.dispatch("updateRepetitionActivity", {
        index,
        repetitions,
      });
    },
    updateVersionNumberActivity(index, versionNumber) {
      console.log("updateVersionNumberActivity");
      this.currentSequence.id = null;
      // Appelle l'action Vuex pour mettre à jour lea versionNumber de l'activité
      this.$store.dispatch("updateVersionNumberActivity", {
        index,
        versionNumber,
      });
    },

    updateTableSequence(id, shared, keyEnabled, key) {
      this.currentSequence.shared = shared;
      this.currentSequence.keyEnabled = keyEnabled;
      this.currentSequence.key = key;
    },

    modalOpenNewSequence(event) {
      this.$buefy.dialog.prompt({
        message: this.$t("Sequence.NAME_SEQUENCE"),
        inputAttrs: {
          type: "text",
          placeholder: "",
          value: "",
        },
        confirmText: this.$t("MenuEleda4Teachers.SET_NAME_BTN"),
        cancelText: this.$t("MenuEleda4Teachers.BTN_CANCEL"),
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, { close }) => {
          close();
          this.currentSequence.name = value;
          this.currentSequence.userId = this.currentUser.id;
          this.currentSequence.sequence_activity_tuples = this.cart;
          this.currentSequence.shared = 0;
          this.currentSequence.keyEnabled = false;
          this.currentSequence.key = "";
          this.dbCreateSequence(this.currentSequence);
          this.isModalOpenActive = false;
        },
      });
    },

    dbCreateSequence(values) {
      this.isLoading = true;
      SequenceDataService.create(values)
        .then((response) => {
          console.log("dbCreateSequence", response);
          this.$buefy.snackbar.open({
            message: this.$t("Sequence.CREATED"),
            type: "is-success",
            position: "is-top",
            actionText: null,
          });
          if (response.data.id) {
            this.$emit("openDropdownCart"); // le dropdown se ferme automatiqument => On envoie un event pour le réouvrir
            this.isLoading = false;
            this.currentSequence.name = response.data.name;
            this.currentSequence.id = response.data.id;
            this.isShareButtonShown = true;

            //            this.$router.push("/sequenceEdit/" + response.data.id);
          }
          //on envoie le signal pour dire
          this.$emit("toBeNotCached", "MySequences");
        })
        .catch((e) => {
          this.isLoading = false;
          console.log(e);
          this.showToast("Error when creating sequence", "is-danger");
        });
    },
  },
};
</script>
